import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FirmwareUpdateApiService {
  url: string = environment.firmwareUpdate;

  constructor(private httpClient: HttpClient) {}

  getFirmwareVersions(): Promise<FirmwareVersion[]> {
    return this.httpClient
      .get<FirmwareVersion[]>(`${this.url}/firmware-versions`)
      .toPromise();
  }
}

export interface FirmwareVersion {
  id: string;
  deletedDate: Date;
  build: string;
  version: string;
  name: string;
  platformType: string;
  createdDate: Date;
  manifestXml: string;
}
